import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import type { SeasonEligibility } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

import { SlideShow } from '../SlideShow';
import { RecentPurchase } from './RecentPurchase';
import { HeaderSection } from '../HeaderSection';
import type { FriendsRecentPurchases_tokenOwner } from './__generated__/index.graphql';

type Props = {
  tokenOwners: FriendsRecentPurchases_tokenOwner[];
  onMarketClick: (slug: string, seasonality: SeasonEligibility) => void;
  track?: ComponentProps<typeof RecentPurchase>['track'];
};
export const FriendsRecentPurchases = ({
  tokenOwners,
  onMarketClick,
  track,
}: Props) => {
  if (tokenOwners.length === 0) {
    return null;
  }
  return (
    <Vertical gap={3}>
      <HeaderSection
        title={
          <FormattedMessage
            id="FriendsRecentPurchases.title.v2"
            defaultMessage="My Circle's Activity"
          />
        }
      />
      <SlideShow>
        <Horizontal gap={1.5}>
          {tokenOwners.map(tokenOwner => (
            <RecentPurchase
              key={tokenOwner.id}
              tokenOwner={tokenOwner}
              onMarketClick={onMarketClick}
              track={track}
            />
          ))}
        </Horizontal>
      </SlideShow>
    </Vertical>
  );
};

FriendsRecentPurchases.fragments = {
  tokenOwner: gql`
    fragment FriendsRecentPurchases_tokenOwner on TokenOwner {
      id
      ...RecentPurchase_tokenOwner
    }
    ${RecentPurchase.fragments.tokenOwner}
  ` as TypedDocumentNode<FriendsRecentPurchases_tokenOwner>,
};
